import { NEARBY_CATEGORIES } from './nearby.config';
import type { NearbyCategoryKey, NearbyContext, NearbyFetchResult } from './nearby.types';

/**
 * Single generic entry point every category goes through. Swallows
 * per-category fetch failures so one broken backend never blocks its
 * sibling "Nearby" strips from rendering.
 */
export async function fetchNearbyData(
  category: NearbyCategoryKey,
  ctx: NearbyContext,
): Promise<NearbyFetchResult<unknown>> {
  try {
    return await NEARBY_CATEGORIES[category].fetchData(ctx);
  } catch {
    return { items: [], total: 0 };
  }
}
